<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdjust_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M6.833 5.333a1.5 1.5 0 0 0-1.5 1.5v6.5H4c-.736 0-1.333.597-1.333 1.334V15c0 .736.597 1.333 1.333 1.333h1.333v8.834a1.5 1.5 0 0 0 3 0v-8.834h1c.737 0 1.334-.597 1.334-1.333v-.333c0-.737-.597-1.334-1.334-1.334h-1v-6.5a1.5 1.5 0 0 0-1.5-1.5m9.334 0a1.5 1.5 0 0 0-1.5 1.5V20h-1.333c-.737 0-1.334.597-1.334 1.333v.334c0 .736.597 1.333 1.334 1.333h1.333v2.167a1.5 1.5 0 0 0 3 0V23h1c.736 0 1.333-.597 1.333-1.333v-.334c0-.736-.597-1.333-1.333-1.333h-1V6.833a1.5 1.5 0 0 0-1.5-1.5M24 6.833a1.5 1.5 0 0 1 3 0V9h.667C28.403 9 29 9.597 29 10.333v.334c0 .736-.597 1.333-1.333 1.333H27v13.167a1.5 1.5 0 0 1-3 0V12h-1.667A1.333 1.333 0 0 1 21 10.667v-.334C21 9.597 21.597 9 22.333 9H24z"
        clip-rule="evenodd"
    />
</svg>
